import { Injectable } from "@angular/core";
import { Constants } from "./app.constants";
import { EncrDecrService } from "./auth/interceptor/encode-decode.service";

@Injectable({
    providedIn: "root"
})

export class StorageService{
    constructor(private encrdecr: EncrDecrService){

    }

    setDataInSessionStorage(key, value){
        // let enc = this.encrdecr.set(Constants.KEY, JSON.stringify(value));
        // sessionStorage.setItem(key, enc);

        sessionStorage.setItem(key, JSON.stringify(value));
    }

    getDataFromSessionStorage(key){
        let val = sessionStorage.getItem(key);
        if(val){
            // let data = this.encrdecr.get(Constants.KEY, val);
            // return JSON.parse(data);

            return JSON.parse(val);
        }
        return null;
    }

    
    setDataInLocalStorage(key, value){
        // debugger;
        // let enc = this.encrdecr.set(Constants.KEY, JSON.stringify(value));
        // localStorage.setItem(key, enc);

        localStorage.setItem(key, JSON.stringify(value));
    }
    
    getDataFromLocalStorage(key){
        let val = localStorage.getItem(key);
        if(val && val != "undefined"){
            // let data = this.encrdecr.get(Constants.KEY, val);
            // return JSON.parse(data);

            return JSON.parse(val);
        }
        return null;
       
    }

    clearStorage(){
        sessionStorage.clear();
        localStorage.clear();
    }

    clearSessionStorageByKey(key){
        sessionStorage.removeItem(key);
    }

    getAccountId(){
        var accountId= null;
        let userData =this.getDataFromLocalStorage(Constants.STORAGE_KEY.USER_INFO);
        if(userData && userData.accountId){
          accountId = userData.accountId;
        }
      return accountId;
    }

}